<template>
    <v-card class="overflow-hidden clickable">
        <v-toolbar
                :color="color"
                dark
                flat
        >
            <v-toolbar-title class="grs-card-title px-0">
                {{ title }}
            </v-toolbar-title>
            <v-btn
                    small
                    icon
                    @click="fetchReports()"
            >
                <v-icon :class="{ 'mdi-spin' : loading }">mdi-cached</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <span>
                   {{$t('display_price', { price : $n(totalIncome) })}}
                </span>

        </v-toolbar>
        <v-list dense active-class="pink--text">
            <v-list-item v-for="(report, index) in reports" :key="index" >
                <v-list-item-title>{{$t('commission_type')[report.type]}} ({{report.commission_rate}}%)</v-list-item-title>
                <v-list-item-title class="text-left">
                    {{$t('display_price', { price : $n(report.total_amount) })}}
                </v-list-item-title>
            </v-list-item>

            <v-list-item  v-if="reports.length <= 0">
                <v-list-item-title>بدون درآمد</v-list-item-title>
            </v-list-item>
        </v-list>
    </v-card>
</template>

<script>
    import Service from '../services/CommissionsService';

    export default {
        props: {
            title: {
                type: String,
                default: 'مجموع ورودی'
            },
            filters: {
                default : () => []
            },
            color:{
                type: String,
                default: 'success'
            }

        },
        data() {
            return {
                loading: false,
                reports : []
            }
        },
        computed: {
            totalIncome() {
                return this.reports
                    .reduce( (totalAmount, {total_amount}) => parseInt(total_amount) + totalAmount, 0);

            },
        },
        mounted() {
            this.fetchReports();
        },
        methods: {
            async fetchReports() {
                this.loading = true;
                try {
                    let {
                        data
                    } = await Service.getOverviewReport(null, this.filters);
                    this.reports = data.value.commission_report;
                } finally {
                    this.loading = false;
                }
            }
        }
    }
</script>